import { Component, Input } from "@angular/core";
// Global, unencapsulated stylesheet: injected via this side-effect import, not Angular's
// styleUrls/styleUrl, so it isn't scoped to this component.
import "./spinner.component.scss";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
})
export class SpinnerComponent {
  @Input() showSpinner = false;
  @Input() diameter: number | undefined;
  @Input() hasContainer = true;
}
